import React from "react";
import { useTranslation } from "react-i18next";

// Assets
import "~/assets/sass/pages/invest/IrModal/shareholder.scss";
import { thousandFormatter } from "~/utils/formatter";

const ShareholderView = ({ irShareholder }) => {
	const { t } = useTranslation();
	const stockList = [];
	const ratioList = [];
	irShareholder.forEach((d) => {
		stockList.push(parseInt(d.total));
		ratioList.push(parseFloat(d.ratio));
	});

	let stockSum = 0;
	let ratioSum = 0;
	stockList.forEach((item) => {
		stockSum += item;
	});
	ratioList.forEach((item) => {
		ratioSum += item;
	});

	return (
		<>
			<div className="shareholder-view">
				<h3 className="section-title">
					{t("pages.investment.InvestEvalPage.detail.modal.shareholder.title")}
				</h3>
				<div className="shareholder_table">
					<div className="thead">
						<div className="tr">
							<div className="th shareholder-name">
								{t(
									"pages.investment.InvestEvalPage.detail.modal.shareholder.tableHead01"
								)}
							</div>
							<div className="th shareholder-amount">
								{t(
									"pages.investment.InvestEvalPage.detail.modal.shareholder.tableHead02"
								)}
							</div>
							<div className="th shareholder-ratio">
								{t(
									"pages.investment.InvestEvalPage.detail.modal.shareholder.tableHead03"
								)}
							</div>
							<div className="th shareholder-remark">
								{t(
									"pages.investment.InvestEvalPage.detail.modal.shareholder.tableHead04"
								)}
							</div>
						</div>
					</div>

					<div className="tbody">
						{irShareholder.map((d) => {
							return (
								<div className="tr" key={d.idx}>
									<div className="td shareholder-name">{d.name}</div>
									<div className="td shareholder-amount">
										{thousandFormatter(d.total)}
									</div>
									<div className="td shareholder-ratio">{d.ratio}%</div>
									<div className="td shareholder-remark">{d.etc}</div>
								</div>
							);
						})}
					</div>
					<div className="tfoot">
						<div className="tr">
							<div className="td">
								{t(
									"pages.investment.InvestEvalPage.detail.modal.shareholder.tableFoot"
								)}
							</div>
							<div className="td shareholder-amount">
								{thousandFormatter(stockSum)}
							</div>
							<div className="td shareholder-ratio">{ratioSum}%</div>
							<div className="td" />
						</div>
					</div>
				</div>
				{/*데이터 없음*/}
				{/*<div className="no-content">*/}
				{/*	등록된 주주가 없습니다.*/}
				{/*</div>*/}
			</div>
		</>
	);
};

export default ShareholderView;
